import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of} from 'rxjs';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {AppState} from "../../../shared/state/app.state";
import {
  reRunBulkUpload, reRunBulkUploadFailure, reRunBulkUploadSuccess,
  runBulkUploadFailure,
  runBulkUploadLibrary,
  runBulkUploadLibraryFailure,
  runBulkUploadLibrarySuccess,
  runBulkUploadSuccess
} from "./bulk-upload.action";
import {BulkUploadService} from "../../data-access/bulk-upload.service";
import {createBlobContainerSuccess} from "../tenant/tenant.action";


@Injectable()
export class BulkUploadEffects {
  runBulkUpload$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createBlobContainerSuccess),
      switchMap((action) =>
        this.bulkUploadService.runBulkUpload(action.tenant, action.bulkUploadFile)
          .pipe(
            map((tenant) => runBulkUploadSuccess({tenant: tenant})),
            catchError((error) => of(runBulkUploadFailure({ error: error.error })))
          )
      )
    )
  );

  reRunBulkUpload$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reRunBulkUpload),
      switchMap((action) =>
        this.bulkUploadService.runBulkUpload(action.tenant, action.bulkUploadFile)
          .pipe(
            map((tenant) => reRunBulkUploadSuccess({tenant: tenant})),
            catchError((error) => of(reRunBulkUploadFailure({ error })))
          )
      )
    )
  );

  runBulkUploadLibrary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(runBulkUploadLibrary),
      switchMap((action) =>
        this.bulkUploadService.runBulkUploadLibrary(action.file)
          .pipe(
            map((file) => runBulkUploadLibrarySuccess({file: file})),
            catchError((error) => of(runBulkUploadLibraryFailure({ error })))
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private bulkUploadService: BulkUploadService
  ) {}
}
